module.exports = __webpack_public_path__ + "static/media/silver-title.1a018762.jpg";